<template>
  <path
    d="M18 8.00018H17V6.00018C17 3.24018 14.76 1.00018 12 1.00018C9.24 1.00018 7 3.24018 7 6.00018V8.00018H6C4.9 8.00018 4 8.90018 4 10.0002V20.0002C4 21.1002 4.9 22.0002 6 22.0002H18C19.1 22.0002 20 21.1002 20 20.0002V10.0002C20 8.90018 19.1 8.00018 18 8.00018ZM12 17.0002C10.9 17.0002 10 16.1002 10 15.0002C10 13.9002 10.9 13.0002 12 13.0002C13.1 13.0002 14 13.9002 14 15.0002C14 16.1002 13.1 17.0002 12 17.0002ZM9 8.00018V6.00018C9 4.34018 10.34 3.00018 12 3.00018C13.66 3.00018 15 4.34018 15 6.00018V8.00018H9Z"
  />
</template>
